import React from 'react';
import styled from 'styled-components';
import Breathe from '../../components/Breathe/Breathe';
import prediction from '../../assets/prediction.png';



const Lower= styled.div`
  display: flex;
  flex-direction:row;
  width: 100%;
  height: auto;
  margin-top:10px;
  @media (max-width: 768px) {
    flex-direction:column;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction:column;

  height: auto;
  margin-left:10px;
  justify-content: flex-start;
`;

const Right = styled.div`
  display: flex;
  flex-direction:column;

  height: auto;
  margin-left:10px;
  margin-right:10px;
  justify-content: space-around;


`;

const Trend = styled.div`
  display: flex;
  flex-direction:row;
  width: 100%;
  height: auto;
  float:bottom;

`;

const Pred = styled.div`
  display: flex;
  flex-direction:row;
  width: 100%;
  height: auto;
  float:bottom;

`;

const Label = styled.span`
  font-size: 0.9rem;
  color: #ffffff;
  text-transform: uppercase;
  line-height: 1;
  letter-spacing: 1px;
    align-self:center;

`;


const Metricsm = styled.h3`
  font-size: 1rem;
  color: #ffffff;
  font-weight:300;
  margin-left:5px;
  justify-content:left;
  align-self:center;
  margin-top:0px;
  margin-bottom:0px;
`;

const ConbarBg = styled.div`
  background: linear-gradient(90deg, #13F9B2, #00FFF9);
  Width: 140px;
  height: 12px;
  border-radius:30px;
  justify-content:left;
  align-self:center;
  margin-top:10px;
  margin-bottom:10px;
  box-shadow:inset 0px 1px 3px 2px rgba(0,0,0,0.35);
`;

const ThreatBg01 = styled.div`
  background: linear-gradient(0deg, #13F9B2, #00FFF9);
  Width: 18px;
  height: 18px;
  border-radius:50px;
  justify-content:left;
  align-self:top;
  margin-top:20px;
  margin-bottom:30px;
  margin-right:10px;
  opacity: 40%;
  box-shadow:inset 0px 0.5px 3px 2px rgba(0,0,0,0.35);
`;
const ThreatBg02 = styled.div`
  background: linear-gradient(0deg, #13F9B2, #00FFF9);
  Width: 18px;
  height: 18px;
  border-radius:50px;
  justify-content:left;
  align-self:top;
  margin-top:20px;
  margin-bottom:30px;
  margin-right:10px;
  opacity: 100%;
  box-shadow:inset 0px 0.5px 3px 2px rgba(0,0,0,0.35);
`;

const ThreatLv = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: left;
`;



const Trendico = styled.img`
  margin-left:0px;
  margin-right:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:30px;
  height:30px;

`;

const Predico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:15px;
  height:auto;
  margin-right:5px;
  margin-bottom:2px;
`;



const Pulse = styled.div`
  display: flex;
  flex-direction:row;
  width: 30px;
  height: 45px;
  float:bottom;
  justify-content: space-around;
`;



const Description = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  
`;

const Content = styled.div`

  justify-content:left;
`;



const ReusableDetailCard = (props) => {

  return(

            
  <Lower>
    <Left>
     <Content>
      <Label>CURRENT DIAGNOSIS</Label>
        <Trend>
        <Pulse>
        <Trendico src = {props.trend}/>
        <Breathe/>
        </Pulse>
          
          
          <Metricsm>{props.metricsm}</Metricsm>
        </Trend>

      <Description>{props.diagnosis}</Description>
      <Pred>
      <Predico src= {prediction}/>
      <Label>PREDICTION</Label>
      </Pred>
      <Description>{props.prediction}</Description>
      
     </Content>
    </Left>
    <Right>
     <Content>
      <Label>{props.significanceorthreat}</Label>
      <ThreatLv>
      <ThreatBg02/>
      <ThreatBg02/>
      <ThreatBg02/>
      <ThreatBg01/>
      </ThreatLv>
      
      <Label>{props.confidence}</Label>

      <ConbarBg/>
      
     </Content>
    </Right>
   </Lower>
);
}
export default ReusableDetailCard;
